import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import Admin from "apis/Admin";


export const verifyNewsRequest = createAsyncThunk("verifyNews",async([start,limit])=>{
  const response = await Admin.get(`news/verification/${start}/${limit}`);
  console.log(response,"news response")
  return response.data.data
});

export const acceptNewsVerify = createAsyncThunk(
  "verifyNews accept",
  async (data) => {
    await Admin.post("news/verify",data);
    console.log("delete data")
    return data;
  }
)
export const rejectNewsRequest = createAsyncThunk(
  "rejectNews",
  async (data) => {
    await Admin.post("news/reject",data);
    console.log("delete data")
    return data;
  }
)


const verifyNewsSlice = createSlice({
  name:"verifyNews",
  initialState:{verifyNewsList:[],totalList:'',message:"",loading:false},
  reducers:{},
  extraReducers:{
    [verifyNewsRequest.fulfilled]:(state,action) => {
      return { ...state, verifyNewsList:action.payload.news, totalList: action.payload.totalNews,message:action.payload.message,loading:false}
    },
    [verifyNewsRequest.pending]:(state) => {
       return {...state,loading:true}
    },
    [verifyNewsRequest.rejected]:(state,action) => {
      return {
        ...state,
        verifyNewsList:action.payload,
        message:"no data",
        loading:false
      }
    },
    [acceptNewsVerify.fulfilled]: (state, _action) => {
      const status = state.verifyNewsList
      console.log(status,"status")
      return {
        ...state,
        //verifyNewsList: status,
        loading: false
      };
    },
    [acceptNewsVerify.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [acceptNewsVerify.rejected]: (state) => {
      return {
        ...state,
        loading: false,
        message: "News Deletion Failed"
      };
    },
    [rejectNewsRequest.fulfilled]: (state, _action) => {
      const status = state.verifyNewsList
      console.log(status,"status")
      return {
        ...state,
        //verifyNewsList: status,
        loading: false
      };
    },
    [rejectNewsRequest.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [rejectNewsRequest.rejected]: (state) => {
      return {
        ...state,
        loading: false,
        message: "News Deletion Failed"
      };
    },
  }
})

export default verifyNewsSlice.reducer;